import React, { useEffect, useState, useContext } from "react";
import Chart from "react-apexcharts";
import { ApexOptions } from "apexcharts";
import { DashboardContext } from "../../../../../contexts/Dashboard/DashboardContext";
import HeaderComponent from "../../../../HeaderComponent";
import LoadingGraphics from "../../../../Loading/LoadingGraphics";
import { Routes } from ".";

interface Finished {
  region?: string,
  until_11: {
    today: number,
    last_weekdays_avg: number,
    last_weeks_avg: number
  },
  until_14: {
    today: number,
    last_weekdays_avg: number,
    last_weeks_avg: number
  },
  after_14: {
    today: number,
    last_weekdays_avg: number,
    last_weeks_avg: number
  }
}

export const ChartBar = ({ data }: Routes) => {
  const { getSizesComponent, setFontSize } = useContext(DashboardContext);
  const [completeRequisition, setCompleteRequisition] = useState(false);
  const [heightChart, setHeightChart] = useState(300);
  const [widthChart, setWidthChart] = useState(300);

  const [until11Today, setUntil11Today] = useState<number[]>([]);
  const [until11LastWeekdaysAvg, setUntil11LastWeekdaysAvg] = useState<number[]>([]);
  const [until11LastWeeksAvg, setUntil11LastWeeksAvg] = useState<number[]>([]);
  const [until14Today, setUntil14Today] = useState<number[]>([]);
  const [until14LastWeekdaysAvg, setUntil14LastWeekdaysAvg] = useState<number[]>([]);
  const [until14LastWeeksAvg, setUntil14LastWeeksAvg] = useState<number[]>([]);
  const [after14Today, setAfter14oday] = useState<number[]>([]);
  const [after14LastWeekdaysAvg, setAfter14astWeekdaysAvg] = useState<number[]>([]);
  const [after14LastWeeksAvg, setAfter14astWeeksAvg] = useState<number[]>([]);
  const [categories, setCategories] = useState<string[]>([]);

  useEffect(() => {
    setUntil11Today(
      data.finished.map(function (route: Finished) {
        return route.until_11.today;
      })
    );
    setUntil11LastWeekdaysAvg(
      data.finished.map(function (route: Finished) {
        return route.until_11.last_weekdays_avg;
      })
    );
    setUntil11LastWeeksAvg(
      data.finished.map(function (route: Finished) {
        return route.until_11.last_weeks_avg;
      })
    );
    setUntil14Today(
      data.finished.map(function (route: Finished) {
        return route.until_14.today;
      })
    );
    setUntil14LastWeekdaysAvg(
      data.finished.map(function (route: Finished) {
        return route.until_14.last_weekdays_avg;
      })
    );
    setUntil14LastWeeksAvg(
      data.finished.map(function (route: Finished) {
        return route.until_14.last_weeks_avg;
      })
    );
    setAfter14oday(
      data.finished.map(function (route: Finished) {
        return route.after_14.today;
      })
    );
    setAfter14astWeekdaysAvg(
      data.finished.map(function (route: Finished) {
        return route.after_14.last_weekdays_avg;
      })
    );
    setAfter14astWeeksAvg(
      data.finished.map(function (route: Finished) {
        return route.after_14.last_weeks_avg;
      })
    );
    setCategories(
      data.finished.map(function (route: Finished) {
        return route.region ? route.region : '';
      })
    );

  }, [data]);

  const series = [
    {
      name: "Até as 11:00 - Média histórica rotas",
      group: 'until11',
      data: until11LastWeeksAvg,
    },
    {
      name: "Até as 11:00 - Média histórica dia x dia",
      group: 'until11',
      data: until11LastWeekdaysAvg,
    },
    {
      name: "Até as 11:00 - Dia atual",
      group: 'until11',
      data: until11Today,
    },
    {
      name: "Até as 14:00 - Média histórica rotas",
      group: 'until14',
      data: until14LastWeeksAvg,
    },
    {
      name: "Até as 14:00 - Média histórica dia x dia",
      group: 'until14',
      data: until14LastWeekdaysAvg,
    },
    {
      name: "Até as 14:00 - Dia atual",
      group: 'until14',
      data: until14Today,
    },
    {
      name: "A partir das 14:00 - Média histórica rotas",
      group: 'after14',
      data: after14LastWeeksAvg,
    },
    {
      name: "A partir das 14:00 - Média histórica dia x dia",
      group: 'after14',
      data: after14LastWeekdaysAvg,
    },
    {
      name: "A partir das 14:00 - Dia atual",
      group: 'after14',
      data: after14Today,
    },
  ];

  const options: ApexOptions = {
    chart: {
      animations: {
        dynamicAnimation: {
          enabled: true,
          speed: 350,
        },
        enabled: false,
      },
      type: "bar",
      stacked: true,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
    },
    colors: ["#3D699C", "#fd6763", "#FFA04D"],
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"]
    },
    responsive: [
      {
        breakpoint: 480,
      },
    ],
    dataLabels: {
      enabled: true,
      textAnchor: "start",
      style: {
        fontSize: "13px",
        fontWeight: 900,
      },
      formatter: function (val) {
          return `${val}` ;
      },
    },
    plotOptions: {
      bar: {
        barHeight: "90%",
        horizontal: true,
      },
    },
    xaxis: {
      categories: categories,
      type: 'category',
      labels: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        maxWidth: 250
      },
    },
    grid: {
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    legend: { 
      show: true,
      position: 'top',
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      enabledOnSeries: [0,1,2,3,4,5,6,7,8],
      x: {
        formatter: function(value, { seriesIndex }) {
          if(seriesIndex < 3) {
            return `${value} </br> Até as 11:00`
          } else if(seriesIndex < 6) {
            return `${value} </br> Até as 14:00`
          } else if(seriesIndex < 9) {
            return `${value} </br> A partir das 14:00`
          } else {
            return `${value}`;
          }
        }
      },
      y: {
        formatter: function (value, { seriesIndex, dataPointIndex, w}) {
          console.log(w.globals.seriesNames[seriesIndex])
          if(seriesIndex === 0) {
            return `
              ${w.globals.seriesNames[seriesIndex].split('-')[1]}: ${(Number(until11LastWeeksAvg[dataPointIndex])/(Number(until11LastWeeksAvg[dataPointIndex]) + Number(until14LastWeeksAvg[dataPointIndex]) + Number(after14LastWeeksAvg[dataPointIndex])) * 100).toFixed(2)}% 
              </br> Total: ${(Number(until11LastWeeksAvg[dataPointIndex]) + Number(until14LastWeeksAvg[dataPointIndex]) + Number(after14LastWeeksAvg[dataPointIndex]))}`
          } else if(seriesIndex === 1) {
            return `
              ${w.globals.seriesNames[seriesIndex].split('-')[1]}: ${(Number(until11LastWeekdaysAvg[dataPointIndex])/(Number(until11LastWeekdaysAvg[dataPointIndex]) + Number(until14LastWeekdaysAvg[dataPointIndex]) + Number(after14LastWeekdaysAvg[dataPointIndex])) * 100).toFixed(2)}% 
              </br> Total: ${(Number(until11LastWeekdaysAvg[dataPointIndex]) + Number(until14LastWeekdaysAvg[dataPointIndex]) + Number(after14LastWeekdaysAvg[dataPointIndex]))}`
          } else if(seriesIndex === 2) {
            return `
              ${w.globals.seriesNames[seriesIndex].split('-')[1]}: ${(Number(until11Today[dataPointIndex])/(Number(until11Today[dataPointIndex]) + Number(until14Today[dataPointIndex]) + Number(after14Today[dataPointIndex])) * 100).toFixed(2)}% 
              </br> Total: ${(Number(until11Today[dataPointIndex]) + Number(until14Today[dataPointIndex]) + Number(after14Today[dataPointIndex]))}`
          } else if(seriesIndex === 3) {
            return `
              ${w.globals.seriesNames[seriesIndex].split('-')[1]}: ${(Number(until14LastWeeksAvg[dataPointIndex])/(Number(until11LastWeeksAvg[dataPointIndex]) + Number(until14LastWeeksAvg[dataPointIndex]) + Number(after14LastWeeksAvg[dataPointIndex])) * 100).toFixed(2)}% 
              </br> Total: ${(Number(until11LastWeeksAvg[dataPointIndex]) + Number(until14LastWeeksAvg[dataPointIndex]) + Number(after14LastWeeksAvg[dataPointIndex]))}`
          } else if(seriesIndex === 4) {
            return `
              ${w.globals.seriesNames[seriesIndex].split('-')[1]}: ${(Number(until14LastWeekdaysAvg[dataPointIndex])/(Number(until11LastWeekdaysAvg[dataPointIndex]) + Number(until14LastWeekdaysAvg[dataPointIndex]) + Number(after14LastWeekdaysAvg[dataPointIndex])) * 100).toFixed(2)}% 
              </br> Total: ${(Number(until11LastWeekdaysAvg[dataPointIndex]) + Number(until14LastWeekdaysAvg[dataPointIndex]) + Number(after14LastWeekdaysAvg[dataPointIndex]))}`
          } else if(seriesIndex === 5) {
            return `
              ${w.globals.seriesNames[seriesIndex].split('-')[1]}: ${(Number(until14Today[dataPointIndex])/(Number(until11Today[dataPointIndex]) + Number(until14Today[dataPointIndex]) + Number(after14Today[dataPointIndex])) * 100).toFixed(2)}% 
              </br> Total: ${(Number(until11Today[dataPointIndex]) + Number(until14Today[dataPointIndex]) + Number(after14Today[dataPointIndex]))}`
          } else if(seriesIndex === 6) {
            return `
              ${w.globals.seriesNames[seriesIndex].split('-')[1]}: ${(Number(after14LastWeeksAvg[dataPointIndex])/(Number(until11LastWeeksAvg[dataPointIndex]) + Number(until14LastWeeksAvg[dataPointIndex]) + Number(after14LastWeeksAvg[dataPointIndex])) * 100).toFixed(2)}% 
              </br> Total: ${(Number(until11LastWeeksAvg[dataPointIndex]) + Number(until14LastWeeksAvg[dataPointIndex]) + Number(after14LastWeeksAvg[dataPointIndex]))}`
          } else if(seriesIndex === 7) {
            return `
              ${w.globals.seriesNames[seriesIndex].split('-')[1]}: ${(Number(after14LastWeekdaysAvg[dataPointIndex])/(Number(until11LastWeekdaysAvg[dataPointIndex]) + Number(until14LastWeekdaysAvg[dataPointIndex]) + Number(after14LastWeekdaysAvg[dataPointIndex])) * 100).toFixed(2)}% 
              </br> Total: ${(Number(until11LastWeekdaysAvg[dataPointIndex]) + Number(until14LastWeekdaysAvg[dataPointIndex]) + Number(after14LastWeekdaysAvg[dataPointIndex]))}`
          } else if(seriesIndex === 8) {
            return `
              ${w.globals.seriesNames[seriesIndex].split('-')[1]}: ${(Number(after14Today[dataPointIndex])/(Number(until11Today[dataPointIndex]) + Number(until14Today[dataPointIndex]) + Number(after14Today[dataPointIndex])) * 100).toFixed(2)}% 
              </br> Total: ${(Number(until11Today[dataPointIndex]) + Number(until14Today[dataPointIndex]) + Number(after14Today[dataPointIndex]))}`
          } else {
            return `${value}`
          }
        },
        title: {
          formatter: function(seriesName) {
            return ``
          }
        }
      }
    }
  };

  useEffect(() => {
    const sizes = getSizesComponent({ id: "chart-routes-finished-on-interval" });
    if (sizes.width < 345) {
      setFontSize({ id: "chart-routes-finished-on-interval", width: sizes.width });
    }

    setHeightChart(sizes.height - 40);
    setWidthChart(sizes.width);
    setCompleteRequisition(true);
  }, []);

  return completeRequisition ? (
    <div className="h100">
      <HeaderComponent
        title={`Gráfico - Quantidade e Faixa Horário de Término Real % das Rotas`}
        id="chart-routes-finished-on-interval"
      />
      <div id="chart">
        <Chart
          type="bar"
          options={options}
          series={series}
          height={heightChart}
          width={widthChart}
        />
      </div>
    </div>
  ) : (
    <LoadingGraphics/>
  );
};